<template>
    <div class="modal fade" id="builder_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content TripleTableGrouping">
                <div class="modal-header padding-x15 padding-y10">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4 select-element-name">
                            <h6>Name your element</h6>
                            <div>
                                <input v-model="name" type="text" class="form-control">
                                <div class="invalid-feedback">Element with name {{ name }} already exists.</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <ul class="nav nav-tabs nav-fill" id="triple_table_grouping_tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="table_1_tab" data-toggle="tab" href="#table_1" role="tab" aria-controls="table_1" aria-selected="true" @click="setTabSelected(1)">TABLE 1</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="table_2_tab" data-toggle="tab" href="#table_2" role="tab" aria-controls="table_2" aria-selected="false" @click="setTabSelected(2)">TABLE 2</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="table_3_tab" data-toggle="tab" href="#table_3" role="tab" aria-controls="table_3" aria-selected="false" @click="setTabSelected(3)">TABLE 3</a>
                        </li>
                    </ul>

                    <div class="tab-content" id="triple_table_grouping_tab_content">
                        <div class="tab-pane show active padding-top15" id="table_1" role="tabpanel" aria-labelledby="table_1_tab">
                            <div class="row">
                                <div class="col-4 select-element-name">
                                    <h6>Name your table</h6>
                                    <div>
                                        <input v-model="table_name_1" type="text" class="form-control">
                                    </div>
                                </div>

                                <div class="col-4 offset-1 position-relative">
                                    <h6>Select table type</h6>
                                    <v-select :clearable="false" v-model="reporting_table_type_1" :reduce="reporting_table_type => reporting_table_type.type" label="type" :options="reporting_table_types"></v-select>

                                    <template v-if="(selected_data_source_1 === callRailId) || (reporting_table_type_1 != 'Traffic Sources')">
                                        <div class="row position-absolute w-100" v-if="reporting_table_type_configurations_1.length > 0">
                                            <template v-if="reporting_table_type_configuration.is_common === false" v-for="reporting_table_type_configuration in reporting_table_type_configurations_1">
                                                <div v-if="reporting_table_type_configuration.selector_type_id === 1 && reporting_table_type_configuration.name != 'Show definitions'" class="col-12 margin-top20">
                                                    <p-input v-model="reporting_table_type_configurations_selected_1[reporting_table_type_configuration.name]" @change="changeReportingTableConfig(reporting_table_type_configuration, $event, 1)" class="p-default p-curve single" type="checkbox"> {{ reporting_table_type_configuration.name }}</p-input>
                                                </div>

                                                <div v-if="reporting_table_type_configuration.selector_type_id === 2" :class="reporting_table_type_configuration.name === 'Campaign Groupings' || reporting_table_type_configuration.name === 'Index Comparison' ? 'col-12' : 'col-6'" class="margin-top20">
                                                    <h6>{{ reporting_table_type_configuration.name }}</h6>
                                                    <v-select :clearable="false" :value="reporting_table_type_configurations_selected_1[reporting_table_type_configuration.name]" @input="changeReportingTableConfig(reporting_table_type_configuration, $event, 1)" :options="reporting_table_type_configuration.values"></v-select>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div class="row margin-top20">
                                <div class="col-4 select-data-source">
                                    <h6>Select data source</h6>
                                    <v-select :clearable="false" v-model="selected_data_source_1" :reduce="data_source => data_source.id" label="name" :options="getDataSources"></v-select>
                                </div>
                            </div>

                            <div class="row margin-top20">
                                <h6 class="col-12">Select metrics</h6>

                                <div class="col-4">
                                    <div class="metrics-list-selections">
                                        <input v-model="search_metric_1" placeholder="Search for a metric..." type="search" class="form-control">

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <li v-if="getMetrics1.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                                <li v-for="metric in getMetrics1" @click="selectMetric(metric.id, $event, 1)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 align-self-center padding-x5">
                                    <button @click="applySelectedMetrics(1)" class="btn btn-info">Apply</button>
                                </div>

                                <div class="col-5">
                                    <div class="metrics-list-selected">
                                        <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics_1.length }} of {{ max_metrics_visible1 || 'TBD' }})</h6>

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <draggable v-model="selected_metrics_1" :disabled="metric_sort_disabled_1" @start="drag=true" @end="drag=false">
                                                    <li v-if="selected_metrics_1.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                                    <li v-else v-for="metric in selected_metrics_1" class="list-group-item padding-x10 padding-y5">
                                                        <span v-if="!metric.is_editing">
                                                            <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                            <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                        </span>
                                                        <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event, 1)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                        <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id, 1)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event, 1)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event, 1)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event, 1)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                        <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                        <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                                    </li>
                                                </draggable>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="reporting_table_type_configurations_1.length > 0">
                                <template v-if="reporting_table_type_configuration.is_common === true" v-for="reporting_table_type_configuration in reporting_table_type_configurations_1">
                                    <div v-if="reporting_table_type_configuration.selector_type_id === 1" class="col-12 margin-top20">
                                        <p-input v-model="reporting_table_type_configurations_selected_1[reporting_table_type_configuration.name]" @change="changeReportingTableConfig(reporting_table_type_configuration, $event, 1)" class="p-default p-curve single" type="checkbox"> {{ reporting_table_type_configuration.name }}</p-input>
                                    </div>

                                    <div v-if="reporting_table_type_configuration.selector_type_id === 2" class="col-6 margin-top20">
                                        <h6>{{ reporting_table_type_configuration.name }}</h6>
                                        <v-select :clearable="false" :value="reporting_table_type_configurations_selected_1[reporting_table_type_configuration.name]" @input="changeReportingTableConfig(reporting_table_type_configuration, $event, 1)" :options="reporting_table_type_configuration.values"></v-select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="tab-pane padding-top15" id="table_2" role="tabpanel" aria-labelledby="table_2_tab">
                            <div class="row">
                                <div class="col-4 select-element-name">
                                    <h6>Name your table</h6>
                                    <div>
                                        <input v-model="table_name_2" type="text" class="form-control">
                                    </div>
                                </div>

                                <div class="col-4 offset-1 position-relative">
                                    <h6>Select table type</h6>
                                    <v-select :clearable="false" v-model="reporting_table_type_2" :reduce="reporting_table_type => reporting_table_type.type" label="type" :options="reporting_table_types"></v-select>

                                    <template v-if="(selected_data_source_2 === callRailId) || (reporting_table_type_2 != 'Traffic Sources')">
                                        <div class="row position-absolute w-100" v-if="reporting_table_type_configurations_2.length > 0">
                                            <template v-if="reporting_table_type_configuration.is_common === false" v-for="reporting_table_type_configuration in reporting_table_type_configurations_2">
                                                <div v-if="reporting_table_type_configuration.selector_type_id === 1" class="col-12 margin-top20">
                                                    <p-input v-model="reporting_table_type_configurations_selected_2[reporting_table_type_configuration.name]" @change="changeReportingTableConfig(reporting_table_type_configuration, $event, 2)" class="p-default p-curve single" type="checkbox"> {{ reporting_table_type_configuration.name }}</p-input>
                                                </div>

                                                <div v-if="reporting_table_type_configuration.selector_type_id === 2" :class="reporting_table_type_configuration.name === 'Campaign Groupings' || reporting_table_type_configuration.name === 'Index Comparison' ? 'col-12' : 'col-6'" class="margin-top20">
                                                    <h6>{{ reporting_table_type_configuration.name }}</h6>
                                                    <v-select :clearable="false" :value="reporting_table_type_configurations_selected_2[reporting_table_type_configuration.name]" @input="changeReportingTableConfig(reporting_table_type_configuration, $event, 2)" :options="reporting_table_type_configuration.values"></v-select>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div class="row margin-top20">
                                <div class="col-4 select-data-source">
                                    <h6>Select data source</h6>
                                    <v-select :clearable="false" v-model="selected_data_source_2" :reduce="data_source => data_source.id" label="name" :options="getDataSources"></v-select>
                                </div>
                            </div>

                            <div class="row margin-top20">
                                <h6 class="col-12">Select metrics</h6>

                                <div class="col-4">
                                    <div class="metrics-list-selections">
                                        <input v-model="search_metric_2" placeholder="Search for a metric..." type="search" class="form-control">

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <li v-if="getMetrics2.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                                <li v-for="metric in getMetrics2" @click="selectMetric(metric.id, $event, 2)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 align-self-center padding-x5">
                                    <button @click="applySelectedMetrics(2)" class="btn btn-info">Apply</button>
                                </div>

                                <div class="col-5">
                                    <div class="metrics-list-selected">
                                        <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics_2.length }} of {{ max_metrics_visible2 || 'TBD' }})</h6>

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <draggable v-model="selected_metrics_2" :disabled="metric_sort_disabled_2" @start="drag=true" @end="drag=false">
                                                    <li v-if="selected_metrics_2.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                                    <li v-else v-for="metric in selected_metrics_2" class="list-group-item padding-x10 padding-y5">
                                                        <span v-if="!metric.is_editing">
                                                            <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                            <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                        </span>
                                                        <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event, 2)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                        <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id, 2)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event, 2)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event, 2)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event, 2)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                        <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                        <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                                    </li>
                                                </draggable>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="reporting_table_type_configurations_2.length > 0">
                                <template v-if="reporting_table_type_configuration.is_common === true" v-for="reporting_table_type_configuration in reporting_table_type_configurations_2">
                                    <div v-if="reporting_table_type_configuration.selector_type_id === 1" class="col-12 margin-top20">
                                        <p-input v-model="reporting_table_type_configurations_selected_2[reporting_table_type_configuration.name]" @change="changeReportingTableConfig(reporting_table_type_configuration, $event, 2)" class="p-default p-curve single" type="checkbox"> {{ reporting_table_type_configuration.name }}</p-input>
                                    </div>

                                    <div v-if="reporting_table_type_configuration.selector_type_id === 2" class="col-6 margin-top20">
                                        <h6>{{ reporting_table_type_configuration.name }}</h6>
                                        <v-select :clearable="false" :value="reporting_table_type_configurations_selected_2[reporting_table_type_configuration.name]" @input="changeReportingTableConfig(reporting_table_type_configuration, $event, 2)" :options="reporting_table_type_configuration.values"></v-select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="tab-pane padding-top15" id="table_3" role="tabpanel" aria-labelledby="table_3_tab">
                            <div class="row">
                                <div class="col-4 select-element-name">
                                    <h6>Name your table</h6>
                                    <div>
                                        <input v-model="table_name_3" type="text" class="form-control">
                                    </div>
                                </div>

                                <div class="col-4 offset-1 position-relative">
                                    <h6>Select table type</h6>
                                    <v-select :clearable="false" v-model="reporting_table_type_3" :reduce="reporting_table_type => reporting_table_type.type" label="type" :options="reporting_table_types"></v-select>

                                    <template v-if="(selected_data_source_3 === callRailId) || (reporting_table_type_3 != 'Traffic Sources')">
                                        <div class="row position-absolute w-100" v-if="reporting_table_type_configurations_3.length > 0">
                                            <template v-if="reporting_table_type_configuration.is_common === false" v-for="reporting_table_type_configuration in reporting_table_type_configurations_3">
                                                <div v-if="reporting_table_type_configuration.selector_type_id === 1" class="col-12 margin-top20">
                                                    <p-input v-model="reporting_table_type_configurations_selected_3[reporting_table_type_configuration.name]" @change="changeReportingTableConfig(reporting_table_type_configuration, $event, 3)" class="p-default p-curve single" type="checkbox"> {{ reporting_table_type_configuration.name }}</p-input>
                                                </div>

                                                <div v-if="reporting_table_type_configuration.selector_type_id === 2" :class="reporting_table_type_configuration.name === 'Campaign Groupings' || reporting_table_type_configuration.name === 'Index Comparison' ? 'col-12' : 'col-6'" class="margin-top20">
                                                    <h6>{{ reporting_table_type_configuration.name }}</h6>
                                                    <v-select :clearable="false" :value="reporting_table_type_configurations_selected_3[reporting_table_type_configuration.name]" @input="changeReportingTableConfig(reporting_table_type_configuration, $event, 3)" :options="reporting_table_type_configuration.values"></v-select>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div class="row margin-top20">
                                <div class="col-4 select-data-source">
                                    <h6>Select data source</h6>
                                    <v-select :clearable="false" v-model="selected_data_source_3" :reduce="data_source => data_source.id" label="name" :options="getDataSources"></v-select>
                                </div>
                            </div>

                            <div class="row margin-top20">
                                <h6 class="col-12">Select metrics</h6>

                                <div class="col-4">
                                    <div class="metrics-list-selections">
                                        <input v-model="search_metric_3" placeholder="Search for a metric..." type="search" class="form-control">

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <li v-if="getMetrics3.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                                <li v-for="metric in getMetrics3" @click="selectMetric(metric.id, $event, 3)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 align-self-center padding-x5">
                                    <button @click="applySelectedMetrics(3)" class="btn btn-info">Apply</button>
                                </div>

                                <div class="col-5">
                                    <div class="metrics-list-selected">
                                        <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics_3.length }} of {{ max_metrics_visible3 || 'TBD' }})</h6>

                                        <hr class="margin-x0 margin-y10">

                                        <div>
                                            <ul class="list-group">
                                                <draggable v-model="selected_metrics_3" :disabled="metric_sort_disabled_3" @start="drag=true" @end="drag=false">
                                                    <li v-if="selected_metrics_3.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                                    <li v-else v-for="metric in selected_metrics_3" class="list-group-item padding-x10 padding-y5">
                                                        <span v-if="!metric.is_editing">
                                                            <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                            <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                        </span>
                                                        <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event, 3)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                        <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id, 3)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event, 3)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event, 3)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                        <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event, 3)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                        <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                        <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                                    </li>
                                                </draggable>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="reporting_table_type_configurations_3.length > 0">
                                <template v-if="reporting_table_type_configuration.is_common === true" v-for="reporting_table_type_configuration in reporting_table_type_configurations_3">
                                    <div v-if="reporting_table_type_configuration.selector_type_id === 1" class="col-12 margin-top20">
                                        <p-input v-model="reporting_table_type_configurations_selected_3[reporting_table_type_configuration.name]" @change="changeReportingTableConfig(reporting_table_type_configuration, $event, 3)" class="p-default p-curve single" type="checkbox"> {{ reporting_table_type_configuration.name }}</p-input>
                                    </div>

                                    <div v-if="reporting_table_type_configuration.selector_type_id === 2" class="col-6 margin-top20">
                                        <h6>{{ reporting_table_type_configuration.name }}</h6>
                                        <v-select :clearable="false" :value="reporting_table_type_configurations_selected_3[reporting_table_type_configuration.name]" @input="changeReportingTableConfig(reporting_table_type_configuration, $event, 3)" :options="reporting_table_type_configuration.values"></v-select>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-top20">
                        <div class="col-12">
                            <template v-for="config in element.element_configurations">
                                <div class="margin-bottom10" :class="checkIndexes(config)">
                                    <template v-if="config.config_selector_type === 'checkbox'">
                                        <label>
                                            <p-input v-model="configurations[config.config_id]" @change="changeConfig(config, $event)" class="p-default p-curve single" type="checkbox" :value="config.config_id"> {{ config.config_name }}</p-input>
                                        </label>
                                    </template>

                                    <template v-if="config.config_selector_type === 'selectbox'">
                                        <h6>{{ config.config_name }}</h6>
                                        <div class="col-3 px-0">
                                            <v-select :clearable="false" :value="configurations[config.config_id]" @input="changeConfig(config, $event)" label="name" :options="config.config_values"></v-select>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="modal-footer padding-y10">
                    <button :disabled="build_disabled" @click="buildElement" type="button" class="btn btn-success">{{ edit_mode ? 'Update' : 'Build' }} Element</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            const params = vm.customClone(this.$store.getters.getBuilderPopupParams);

            this.selected_data_source_1    = this.getDataSources[0].id;
            this.selected_data_source_2    = this.getDataSources[0].id;
            this.selected_data_source_3    = this.getDataSources[0].id;
            this.element                   = params.element;
            this.edit_mode                 = params.edit_mode || false;
            this.max_metrics_visible1      = this.reporting_table_type_1 === 'Goal Breakdown' ? 10 : (this.reporting_table_type_1 === 'Downloads' ? 1 : this.element.max_metrics_visible);
            this.max_metrics_visible2      = this.reporting_table_type_2 === 'Goal Breakdown' ? 10 : (this.reporting_table_type_2 === 'Downloads' ? 1 : this.element.max_metrics_visible);
            this.max_metrics_visible3      = this.reporting_table_type_3 === 'Goal Breakdown' ? 10 : (this.reporting_table_type_3 === 'Downloads' ? 1 : this.element.max_metrics_visible);
            this.max_metrics_visible1_copy = this.element.max_metrics_visible;
            this.max_metrics_visible2_copy = this.element.max_metrics_visible;
            this.max_metrics_visible3_copy = this.element.max_metrics_visible;
            this.has_indexes               = this.$store.getters.getBuilderPopupParams.has_indexes;

            let query_string = $.param({excluded_table_types: ['CTA Performance']});
            const client_id = this.$store.getters.getBuilderPopupParams.client_id;
            axios.get(`/api/reporting-table-types/${client_id}?${query_string}`).then(response => {
                this.reporting_table_types = _.values(response.data);

                Object.assign(this.$data, vm.customClone(this.$store.getters.getBuilderPopupParams.data || {}));

                if (!this.edit_mode) {
                    this.triggerReportingTableTypeChange1();
                    this.triggerReportingTableTypeChange2();
                    this.triggerReportingTableTypeChange3();

                    _.each(this.element.element_configurations, config => {
                        if (config.config_selector_type === 'selectbox') {
                            this.configurations[config.config_id] = config.config_values[0];
                        }
                    });
                } else {
                    if (this.reporting_table_type_1 === 'Traffic Sources') {
                        this.triggerReportingTableTypeChange1();
                    }

                    if (this.reporting_table_type_2 === 'Goal Breakdown') {
                        this.triggerReportingTableTypeChange2();
                    }

                    if (this.reporting_table_type_3 === 'Downloads') {
                        this.triggerReportingTableTypeChange3();
                    }
                }

                if(this.selected_metrics_1.length){
                    this.selected_data_source_1 = this.selected_metrics_1[0].data_source_id;
                    if(this.metrics_1.length){
                        _.each(this.metrics_1, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics_1, {id: metric.id}) > -1;
                        });
                    }
                }
                if(this.selected_metrics_2.length){
                    this.selected_data_source_2 = this.selected_metrics_2[0].data_source_id;
                    if(this.metrics_2.length){
                        _.each(this.metrics_2, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics_2, {id: metric.id}) > -1;
                        });
                    }
                }
                if(this.selected_metrics_3.length){
                    this.selected_data_source_3 = this.selected_metrics_3[0].data_source_id;
                    if(this.metrics_3.length){
                        _.each(this.metrics_3, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics_3, {id: metric.id}) > -1;
                        });
                    }
                }

                this.validate();
            });
        },
        mounted(){
            const vueInstance = this;
            setTimeout(() => {
                _.each(vueInstance.element.element_configurations, (config) => {
                    if(config.config_short_name == 'show_index_values'){
                        vueInstance.index_is_checked = vueInstance.configurations[config.config_id];
                    }
                });
            }, 2000)
        },
        data() {
            return {
                name:                                           '',
                original_name:                                  '',
                element:                                        {},
                reporting_table_types:                          [],
                table_name_1:                                   '',
                table_name_2:                                   '',
                table_name_3:                                   '',
                reporting_table_type_1:                         'Traffic Sources',
                reporting_table_type_2:                         'Goal Breakdown',
                reporting_table_type_3:                         'Downloads',
                selected_data_source_1:                         '',
                selected_data_source_2:                         '',
                selected_data_source_3:                         '',
                search_metric_1:                                '',
                search_metric_2:                                '',
                search_metric_3:                                '',
                metrics_1:                                      [],
                metrics_2:                                      [],
                metrics_3:                                      [],
                selected_metrics_1:                             [],
                selected_metrics_2:                             [],
                selected_metrics_3:                             [],
                max_metrics_visible1:                           null,
                max_metrics_visible2:                           null,
                max_metrics_visible3:                           null,
                max_metrics_visible1_copy:                      null,
                max_metrics_visible2_copy:                      null,
                max_metrics_visible3_copy:                      null,
                configurations:                                 {},
                reporting_table_type_configurations_1:          [],
                reporting_table_type_configurations_selected_1: {},
                reporting_table_type_configurations_2:          [],
                reporting_table_type_configurations_selected_2: {},
                reporting_table_type_configurations_3:          [],
                reporting_table_type_configurations_selected_3: {},
                build_disabled:                                 true,
                edit_mode:                                      false,
                initial_run_1:                                  true,
                initial_run_2:                                  true,
                initial_run_3:                                  true,
                metric_sort_disabled_1:                         false,
                metric_sort_disabled_2:                         false,
                metric_sort_disabled_3:                         false,
                has_indexes:                                    false,
                index_is_checked:                               false,
                table_tab_selected:                             1,
                data_source_1_timeout:                          null,
                data_source_2_timeout:                          null,
                data_source_3_timeout:                          null,
                callRailId:                                     null,
                trigger_metrics_1:                              false,
                trigger_metrics_2:                              false,
                trigger_metrics_3:                              false,
            }
        },

        methods: {
            setTabSelected(tab){
                this.table_tab_selected = tab;
            },
            selectMetric(metricId, event, metricIndex) {
                const index = _.findIndex(this['metrics_' + metricIndex], {id: metricId});

                this['metrics_' + metricIndex][index].selected = !$(event.target).hasClass('active');
            },

            applySelectedMetrics(metricIndex) {
                if ((this['selected_metrics_' + metricIndex].length + _.filter(this['metrics_' + metricIndex], {selected: true}).length) > this['max_metrics_visible' + metricIndex]) {
                    this.$notify({
                        type: 'error',
                        text: `The maximum metrics for this is ${this.element['max_metrics_visible' + metricIndex]}. Please remove one of the current metrics if you want to add a replacement.`
                    });

                    return false;
                }

                _.each(this['metrics_' + metricIndex], metric => {
                    if (metric.selected && _.findIndex(this['selected_metrics_' + metricIndex], {id: metric.id}) === -1) {
                        metric.applied  = true;
                        metric.selected = false;

                        this['selected_metrics_' + metricIndex].push(metric);
                    }
                });

                this.validate();
            },

            editAppliedMetricName(metricId, event, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});

                if (index > -1) {
                    this['selected_metrics_' + metricIndex][index].is_editing = true;
                }

                this['metric_sort_disabled_' + metricIndex] = true;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            cancelAppliedMetricName(metricId, event, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});

                if (index > -1) {
                    this['selected_metrics_' + metricIndex][index].is_editing = false;
                }

                this['metric_sort_disabled_' + metricIndex] = false;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            saveAppliedMetricName(metricId, event, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});

                if (index > -1) {
                    this['selected_metrics_' + metricIndex][index].is_editing      = false;
                    this['selected_metrics_' + metricIndex][index].new_metric_name = $(event.target).closest('li').find('.metric-edit').val().trim();

                    let formData = new FormData;
                    formData.append('metric_id', this['selected_metrics_' + metricIndex][index].metric_id);
                    formData.append('new_metric_name', this['selected_metrics_' + metricIndex][index].new_metric_name);
                    formData.append('_method', 'PUT');

                    if (this['selected_metrics_' + metricIndex][index].client_x_metric_x_data_source_id) {
                        formData.append('client_x_metric_x_data_source_id', this['selected_metrics_' + metricIndex][index].client_x_metric_x_data_source_id);
                    } else {
                        formData.append('data_source_ids', JSON.stringify([this['selected_metrics_' + metricIndex][index].data_source_id]));
                    }

                    this.ajaxSubmit({}, 'POST', `/api/metrics/client/${this.$store.getters.getBuilderPopupParams.client_id}/glossary`, formData).then(response => {
                        let queryString = null;

                        for (var j = 1; j <= 3; j++) {
                            queryString = $.param({
                                data_source_id:       this['selected_data_source_' + j],
                                client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                                reporting_table_type: this['reporting_table_type_' + j]
                            });

                            axios.get(`/api/metrics?${queryString}`).then(metrics => {
                                let renamedMetrics = _.filter(metrics.data, metric => {
                                    return metric.client_x_metric_x_data_source_id !== null;
                                });

                                _.each(renamedMetrics, metric => {
                                    let renamedMetricIndex = null;

                                    for (var i = 1; i <= 3; i++) {
                                        renamedMetricIndex = _.findIndex(this['metrics_' + i], {id: metric.id});

                                        if (renamedMetricIndex > -1) {
                                            this['metrics_' + i][renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                            this['metrics_' + i][renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                        }

                                        renamedMetricIndex = _.findIndex(this['selected_metrics_' + i], {id: metric.id});

                                        if (renamedMetricIndex > -1) {
                                            this['selected_metrics_' + i][renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                            this['selected_metrics_' + i][renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                        }
                                    }
                                });
                            });
                        }
                    });
                }

                this['metric_sort_disabled_' + metricIndex] = false;

                this.$forceUpdate();
            },

            removeAppliedMetric(metricId, metricIndex) {
                let index = _.findIndex(this['selected_metrics_' + metricIndex], {id: metricId});
                this['selected_metrics_' + metricIndex].splice(index, 1);

                index = _.findIndex(this['metrics_' + metricIndex], {id: metricId});
                if (index > -1) {
                    this['metrics_' + metricIndex][index].applied = false;
                }

                this.validate();
            },

            buildElement() {
                if (!this.edit_mode) {
                    this.$store.commit('addBuilderElement', {
                        name:                                  this.name || this.$parent.generateElementName(),
                        element_id:                            this.element.id,
                        element_abbreviation:                  this.element.abbreviation,
                        table_name_1:                          this.table_name_1,
                        table_name_2:                          this.table_name_2,
                        table_name_3:                          this.table_name_3,
                        reporting_table_type_1:                this.reporting_table_type_1,
                        reporting_table_type_2:                this.reporting_table_type_2,
                        reporting_table_type_3:                this.reporting_table_type_3,
                        metrics_1:                             this.selected_metrics_1,
                        metrics_2:                             this.selected_metrics_2,
                        metrics_3:                             this.selected_metrics_3,
                        configurations:                        this.configurations,
                        reporting_table_type_configurations_1: this.reporting_table_type_configurations_selected_1,
                        reporting_table_type_configurations_2: this.reporting_table_type_configurations_selected_2,
                        reporting_table_type_configurations_3: this.reporting_table_type_configurations_selected_3
                    });
                } else {
                    this.$store.commit('updateBuilderElement', {
                        data: {
                            name:                                  this.name || this.$parent.generateElementName(),
                            element_id:                            this.element.id,
                            element_abbreviation:                  this.element.abbreviation,
                            table_name_1:                          this.table_name_1,
                            table_name_2:                          this.table_name_2,
                            table_name_3:                          this.table_name_3,
                            reporting_table_type_1:                this.reporting_table_type_1,
                            reporting_table_type_2:                this.reporting_table_type_2,
                            reporting_table_type_3:                this.reporting_table_type_3,
                            metrics_1:                             this.selected_metrics_1,
                            metrics_2:                             this.selected_metrics_2,
                            metrics_3:                             this.selected_metrics_3,
                            configurations:                        this.configurations,
                            reporting_table_type_configurations_1: this.reporting_table_type_configurations_selected_1,
                            reporting_table_type_configurations_2: this.reporting_table_type_configurations_selected_2,
                            reporting_table_type_configurations_3: this.reporting_table_type_configurations_selected_3
                        },

                        name: this.$store.getters.getBuilderPopupParams.data.original_name
                    });
                }

                event_bus.$emit('element_saved', true);

                $('#builder_modal').modal('hide');
            },

            changeConfig(config, value) {
                if(config.config_short_name == 'show_index_values'){
                    this.index_is_checked = value;
                }
                const configId = config.config_id;
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this.configurations[configId] = 'true';
                    } else {
                        delete this.configurations[configId];
                    }
                } else {
                    this.configurations[configId] = value;
                }

                this.$forceUpdate();
            },

            changeReportingTableConfig(config, value, index) {
                this['trigger_metrics_'+index] = !this['trigger_metrics_'+index];
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this['reporting_table_type_configurations_selected_' + index][config.name] = 'true';
                    } else {
                        delete this['reporting_table_type_configurations_selected_' + index][config.name];
                    }
                } else {
                    this['reporting_table_type_configurations_selected_' + index][config.name] = value;
                }

                this.$forceUpdate();
            },

            validate() {
                this.build_disabled = true;

                if (
                    (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    )
                    && this.max_metrics_visible1 >= this.selected_metrics_1.length
                    && this.element.min_metrics_visible <= this.selected_metrics_1.length
                    && this.max_metrics_visible2 >= this.selected_metrics_2.length
                    && this.element.min_metrics_visible <= this.selected_metrics_2.length
                    && this.max_metrics_visible3 >= this.selected_metrics_3.length
                    && this.element.min_metrics_visible <= this.selected_metrics_3.length
                ) {
                    this.build_disabled = false;
                }
            },

            triggerReportingTableTypeChange1() {
                if (this.selected_data_source_1) {
                    const save_selection = this.selected_data_source_1;
                    const queryString = $.param({
                        data_source_id:       this.selected_data_source_1,
                        client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                        reporting_table_type: this.reporting_table_type_1
                    });
                    this.max_metrics_visible1 = this.max_metrics_visible1_copy;

                    if (this.reporting_table_type_1 === 'Goal Breakdown') {
                        this.max_metrics_visible1 = 10;
                    } else if (this.reporting_table_type_1 === 'Downloads') {
                        this.max_metrics_visible1 = 1;
                    }

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = false;
                        });

                        if(save_selection == this.selected_data_source_1){
                            this.metrics_1 = metrics.data;
                        }

                        if (!this.initial_run_1) {
                            this.selected_metrics_1 = [];
                        }

                        this.initial_run_1 = false;
                        this.validate();
                    });

                    let selectedReportingTableType = _.find(this.reporting_table_types, {type: this.reporting_table_type_1});

                    if (selectedReportingTableType) {
                        if (selectedReportingTableType.configurations && selectedReportingTableType.configurations.length > 0) {
                            this.reporting_table_type_configurations_1 = selectedReportingTableType.configurations;

                            if (!this.initial_run_1) {
                                _.each(this.reporting_table_type_configurations_selected_1, (configValue, configName) => {
                                    const conf = _.find(selectedReportingTableType.configurations, {name: configName, is_common: false});

                                    if (!conf) {
                                        delete this.reporting_table_type_configurations_selected_1[configName];
                                    }
                                });
                            }

                            _.each(selectedReportingTableType.configurations, configuration => {
                                if (!this.reporting_table_type_configurations_selected_1[configuration.name]) {
                                    if (configuration.selector_type_id === 2) {
                                        this.reporting_table_type_configurations_selected_1[configuration.name] = configuration.values[0];
                                    }
                                }
                            });
                        } else {
                            this.reporting_table_type_configurations_selected_1 = {};
                            this.reporting_table_type_configurations_1          = [];
                        }
                    }
                }
            },

            triggerReportingTableTypeChange2() {
                if (this.selected_data_source_2) {
                    const save_selection = this.selected_data_source_2;
                    const queryString = $.param({
                        data_source_id:       this.selected_data_source_2,
                        client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                        reporting_table_type: this.reporting_table_type_2
                    });
                    this.max_metrics_visible2 = this.max_metrics_visible2_copy;
                    if (this.reporting_table_type_2 === 'Goal Breakdown') {
                        this.max_metrics_visible2 = 10;
                    } else if (this.reporting_table_type_2 === 'Downloads') {
                        this.max_metrics_visible2 = 1;
                    }

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = false;
                        });

                        if(save_selection == this.selected_data_source_2){
                            this.metrics_2 = metrics.data;
                        }

                        if (!this.initial_run_2) {
                            this.selected_metrics_2 = [];
                        }

                        this.initial_run_2 = false;
                        this.validate();
                    });

                    let selectedReportingTableType = _.find(this.reporting_table_types, {type: this.reporting_table_type_2});

                    if (selectedReportingTableType) {
                        if (selectedReportingTableType.configurations && selectedReportingTableType.configurations.length > 0) {
                            this.reporting_table_type_configurations_2 = selectedReportingTableType.configurations;

                            if (!this.initial_run_2) {
                                _.each(this.reporting_table_type_configurations_selected_2, (configValue, configName) => {
                                    const conf = _.find(selectedReportingTableType.configurations, {name: configName, is_common: false});

                                    if (!conf) {
                                        delete this.reporting_table_type_configurations_selected_2[configName];
                                    }
                                });
                            }

                            _.each(selectedReportingTableType.configurations, configuration => {
                                if (!this.reporting_table_type_configurations_selected_2[configuration.name]) {
                                    if (configuration.selector_type_id === 2) {
                                        this.reporting_table_type_configurations_selected_2[configuration.name] = configuration.values[0];
                                    }
                                }
                            });
                        } else {
                            this.reporting_table_type_configurations_selected_2 = {};
                            this.reporting_table_type_configurations_2          = [];
                        }
                    }
                }
            },

            triggerReportingTableTypeChange3() {
                if (this.selected_data_source_3) {
                    const save_selection = this.selected_data_source_3;
                    const queryString = $.param({
                        data_source_id:       this.selected_data_source_3,
                        client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                        reporting_table_type: this.reporting_table_type_3
                    });
                    this.max_metrics_visible3 = this.max_metrics_visible3_copy;

                    if (this.reporting_table_type_3 === 'Goal Breakdown') {
                        this.max_metrics_visible3 = 10;
                    } else if (this.reporting_table_type_3 === 'Downloads') {
                        this.max_metrics_visible3 = 1;
                    }

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = false;
                        });

                        if(save_selection == this.selected_data_source_3){
                            this.metrics_3 = metrics.data;
                        }

                        if (!this.initial_run_3) {
                            this.selected_metrics_3 = [];
                        }

                        this.initial_run_3 = false;
                        this.validate();
                    });

                    let selectedReportingTableType = _.find(this.reporting_table_types, {type: this.reporting_table_type_3});

                    if (selectedReportingTableType) {
                        if (selectedReportingTableType.configurations && selectedReportingTableType.configurations.length > 0) {
                            this.reporting_table_type_configurations_3 = selectedReportingTableType.configurations;

                            if (!this.initial_run_3) {
                                _.each(this.reporting_table_type_configurations_selected_3, (configValue, configName) => {
                                    const conf = _.find(selectedReportingTableType.configurations, {name: configName, is_common: false});

                                    if (!conf) {
                                        delete this.reporting_table_type_configurations_selected_3[configName];
                                    }
                                });
                            }

                            _.each(selectedReportingTableType.configurations, configuration => {
                                if (!this.reporting_table_type_configurations_selected_3[configuration.name]) {
                                    if (configuration.selector_type_id === 2) {
                                        this.reporting_table_type_configurations_selected_3[configuration.name] = configuration.values[0];
                                    }
                                }
                            });
                        } else {
                            this.reporting_table_type_configurations_selected_3 = {};
                            this.reporting_table_type_configurations_3          = [];
                        }
                    }
                }
            },
            checkIndexes(config){
                if(this.table_tab_selected == 1 && (this.reporting_table_type_1 != 'Goal Breakdown')){
                    if((config.config_short_name == 'show_index_values') || (config.config_short_name == 'select_index_name')){
                        return 'hidden';
                    }

                    return;
                }
                if(this.table_tab_selected == 2 && (this.reporting_table_type_2 != 'Goal Breakdown')){
                    if((config.config_short_name == 'show_index_values') || (config.config_short_name == 'select_index_name')){
                        return 'hidden';
                    }

                    return;
                }

                if(this.table_tab_selected == 3 && (this.reporting_table_type_3 != 'Goal Breakdown')){
                    if((config.config_short_name == 'show_index_values') || (config.config_short_name == 'select_index_name')){
                        return 'hidden';
                    }

                    return;
                }

                if((config.config_short_name == 'show_index_values') && (!this.has_indexes)){
                    return 'hidden';
                }

                if((config.config_short_name == 'select_index_name') && (!this.index_is_checked)){
                    return 'hidden';
                }
            }
        },

        watch: {
            name() {
                if (this.name) {
                    if (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    ) {
                        $('#builder_modal').find('.select-element-name input').removeClass('is-invalid');
                    } else {
                        $('#builder_modal').find('.select-element-name input').addClass('is-invalid');
                    }
                }

                this.validate();
            },

            selected_data_source_1() {
                const self = this;
                if (this.selected_data_source_1) {
                    const queryString = $.param({
                        data_source_id:       this.selected_data_source_1,
                        client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                        reporting_table_type: this.reporting_table_type_1
                    });

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics_1, {id: metric.id}) > -1;
                        });

                        clearInterval(this.data_source_1_timeout);

                        this.metrics_1 = metrics.data;

                        this.data_source_1_timeout = setInterval(()=>{
                            self.metrics_1 = metrics.data;
                        }, 20);
                        setTimeout(() => {
                            clearInterval(this.data_source_1_timeout);
                        }, 3000)
                    });
                }
            },

            selected_data_source_2() {
                const self = this;
                if (this.selected_data_source_2) {
                    const queryString = $.param({
                        data_source_id:       this.selected_data_source_2,
                        client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                        reporting_table_type: this.reporting_table_type_2
                    });

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics_2, {id: metric.id}) > -1;
                        });
                        clearInterval(this.data_source_2_timeout);
                        this.metrics_2 = metrics.data;

                        this.data_source_2_timeout = setInterval(()=>{
                            self.metrics_2 = metrics.data;
                        }, 20);
                        setTimeout(() => {
                            clearInterval(this.data_source_2_timeout);
                        }, 3000)
                    });
                }
            },

            selected_data_source_3() {
                const self = this;
                if (this.selected_data_source_3) {
                    const queryString = $.param({
                        data_source_id:       this.selected_data_source_3,
                        client_id:            this.$store.getters.getBuilderPopupParams.client_id,
                        reporting_table_type: this.reporting_table_type_3
                    });

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics_3, {id: metric.id}) > -1;
                        });

                        clearInterval(this.data_source_3_timeout);

                        this.metrics_3 = metrics.data;

                        this.data_source_3_timeout = setInterval(()=>{
                            self.metrics_3 = metrics.data;
                        }, 20);
                        setTimeout(() => {
                            clearInterval(this.data_source_3_timeout);
                        }, 3000)
                    });
                }
            },

            reporting_table_type_1() {
                this.triggerReportingTableTypeChange1();
            },

            reporting_table_type_2() {
                this.triggerReportingTableTypeChange2();
            },

            reporting_table_type_3() {
                this.triggerReportingTableTypeChange3();
            }
        },

        computed: {
            getMetrics1() {
                this.trigger_metrics_1;
                const form_call = this.reporting_table_type_configurations_selected_1['Attribution Type'];
                return this.metrics_1.filter(metric => {
                    const metricName = metric.new_metric_name || metric.metric_name;

                    const exclude1 = metric.metric_name == 'Number of First Time Answered Calls';
                    const exclude2 = metric.metric_name == 'Avg First Time Call Duration';
                    const submission = metric.metric_name.includes('Submissions');
                    const leads = metric.metric_name.includes('Leads');

                    const check1 = metricName.toLowerCase().indexOf(this.search_metric_1.toLowerCase()) > -1;
                    const check2 = (metric.data_source_abbr == 'cr');
                    const check3 = (form_call == 'Form') && (submission);
                    const check4 = (form_call == 'Call') && (!submission) && (!leads) && (!exclude1) && (!exclude2);
                    const check5 = (form_call == '50/50') && (leads);

                    return check1 && (!check2 || check3 || check4 || check5);
                });
            },

            getMetrics2() {
                this.trigger_metrics_2;
                const form_call = this.reporting_table_type_configurations_selected_2['Attribution Type'];
                return this.metrics_2.filter(metric => {
                    const metricName = metric.new_metric_name || metric.metric_name;

                    const exclude1 = metric.metric_name == 'Number of First Time Answered Calls';
                    const exclude2 = metric.metric_name == 'Avg First Time Call Duration';
                    const submission = metric.metric_name.includes('Submissions');
                    const leads = metric.metric_name.includes('Leads');

                    const check1 = metricName.toLowerCase().indexOf(this.search_metric_2.toLowerCase()) > -1;
                    const check2 = (metric.data_source_abbr == 'cr');
                    const check3 = (form_call == 'Form') && (submission);
                    const check4 = (form_call == 'Call') && (!submission) && (!leads) && (!exclude1) && (!exclude2);
                    const check5 = (form_call == '50/50') && (leads);

                    return check1 && (!check2 || check3 || check4 || check5);
                });
            },

            getMetrics3() {
                this.trigger_metrics_3;
                const form_call = this.reporting_table_type_configurations_selected_3['Attribution Type'];
                return this.metrics_3.filter(metric => {
                    const metricName = metric.new_metric_name || metric.metric_name;

                    const exclude1 = metric.metric_name == 'Number of First Time Answered Calls';
                    const exclude2 = metric.metric_name == 'Avg First Time Call Duration';
                    const submission = metric.metric_name.includes('Submissions');
                    const leads = metric.metric_name.includes('Leads');

                    const check1 = metricName.toLowerCase().indexOf(this.search_metric_3.toLowerCase()) > -1;
                    const check2 = (metric.data_source_abbr == 'cr');
                    const check3 = (form_call == 'Form') && (submission);
                    const check4 = (form_call == 'Call') && (!submission) && (!leads) && (!exclude1) && (!exclude2);
                    const check5 = (form_call == '50/50') && (leads);

                    return check1 && (!check2 || check3 || check4 || check5);
                });
            },

            getDataSources() {
                const callRail = this.$store.getters.getBuilderPopupParams.data_sources.filter(dataSource => {
                    return dataSource.name === 'CallRail';
                });
                if (callRail.length > 0 && callRail[0].id) {
                    this.callRailId = callRail[0].id;
                } else {
                    this.callRailId = null;
                }
                return this.$store.getters.getBuilderPopupParams.data_sources;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #triple_table_grouping_tab_content {
        padding: 0 1.5rem 1.5rem;
        border-left: 0.1rem solid #dee2e6;
        border-right: 0.1rem solid #dee2e6;
        border-bottom: 0.1rem solid #dee2e6;
        border-bottom-left-radius: .5rem;
        border-bottom-right-radius: .5rem;
    }

    .close {
        outline: none;
    }

    .nav-tabs {
        a.nav-link {
            font-weight: 500;
            font-size: 1.2rem;
            color: #37a8cd;

            &.active {
                box-shadow: 0 -0.1rem .3rem #eeeeee;
                color: #37a8cd;
                background-color: #ffffff;
                border-color: #dee2e6 #dee2e6 #ffffff;
            }
        }
    }
</style>
